import { Injectable } from '@angular/core';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueryService {

  constructor() { }
  get attendance() {
    return {
      uri: 'employee_attendance/list',
      data: {
        select: {
          data: 1,
          createdAt: 1,
          user: { profile: { name: 1, employeeId: 1 }, email: 1 },
        }
      }
    };
  }
  get _vehicles() {
    return {
      uri: 'vehicle/list?noref=true',
      data: {
        select: {
          plate: 1,
          uin: 1,
          source: 1,
          type: 1,
          model: 1,
          data: 1,
          createdAt: 1,
          user: { profile: { name: 1, employeeId: 1 }, email: 1 },
        }
      }
    };
  }
  get salaryFormula() {
    return {
      uri: 'formula_salary/list?noref=true&&selectall=true',
      data: {
        select: {
          data: 1,
          createdAt: 1,
          kpi: 1,
          allowances: 1,
          employee: { profile: { name: 1, employeeId: 1, employeeGroup: { name: 1 } } },
          user: { profile: { name: 1, employeeId: 1, employeeGroup: { name: 1 } } },
        }
      }
    };
  }
  get _kpiUnits() {
    return {
      uri: 'employee_kpi_unit/list?noref=true',
      data: {
        select: {
          data: 1,
          name: 1,
          price: 1,
        },
      }
    };
  }
  get _attendance() {
    return {
      uri: 'employee_attendance/list?noref=true',
      data: {
        select: {
          data: 1,
          createdAt: 1,
          user: 1, email: 1,
        },
        limit: 25,
        page: 1,
      }
    };
  }
  get employeeStore() {
    return { uri: 'employee_store/list', data: { select: { stores: { name: 1 }, employee: { 'profile.name': 1 }, user: { 'profile.name': 1 } } } };
  }
  get _employeeStore() {
    return { uri: 'employee_store/list?noref=true', data: { select: { stores: { name: 1 }, employee: 1, user: { 'profile.name': 1 } } } };
  }
  get employeeFaces() {
    return { uri: 'employee_face/list', data: { select: { faceId: 1, employee: { profile: { name: 1 } }, updatedAt: 1, user: { profile: { name: 1 } } } } };
  }
  get _employeeFaces() {
    return { uri: 'employee_face/list?noref=true', data: { select: { faceId: 1, employee: { profile: { name: 1 } }, updatedAt: 1, user: 1 } } };
  }
  get filterUser() {
    return {
      $or: [
        { 'profile.workEnd': { $exists: false } },
        { 'profile.workEnd': { $in: [null, ""] } },
        {
          $and: [
            { 'profile.workEnd': { $exists: true } },
            { 'profile.workEnd': { $gt: new Date() } }
          ]
        }
      ],
      roles: { $nin: ['admin.system', 'admin.station'] }
    }
  }
  get faceMe() {
    return {
      uri: 'employee_face/_get_me'
    };
  }
  get groups() {
    return { uri: 'employee_group/list', data: { select: { name: 1, user: { profile: { name: 1 } } } } };
  }
  get _groups() {
    return {
      uri: 'employee_group/list?noref=true',
      data: {
        select: { createdAt: 1, name: 1, user: { profile: { name: 1 } } }
      }
    };
  }
  get allowanceExtra() {
    return { uri: 'employee_allowance_extra/list', data: { select: { name: 1, type: 1, amount: 1, user: { profile: { name: 1 } } } } };
  }
  get _allowanceExtra() {
    return {
      uri: 'employee_allowance_extra/list?noref=true',
      data: {
        select: { createdAt: 1, name: 1, type: 1, amount: 1, user: { profile: { name: 1 } } },
        filter: {}
      }
    };
  }
  get users() {
    return {
      uri: 'users/list',
      data: {
        select: {
          email: 1,
          createdAt: 1,
          profile: { employeeId: 1, name: 1, phone: 1 },
          'profile.createdBy': { email: 1, profile: { name: 1 } },
          'profile.employeeGroup': { name: 1 },
        },
        filter: this.filterUser || {},
      }
    };
  }
  get _users() {
    return {
      uri: 'users/list?noref=true',
      data: {
        select: {
          createdAt: 1, email: 1, lockedAt: 1, profile: { employeeId: 1, name: 1, employeeGroup: 1, phone: 1 },
          'profile.createdBy': { email: 1, profile: { name: 1 } },
        },
        filter: this.filterUser || {},
      }
    };
  }
  get timesheets() {
    return {
      uri: 'employee_timesheet/list',
      data: { select: { name: 1, workDays: 1, user: { profile: { name: 1 } } } }
    };
  }
  get _timesheets() {
    return {
      uri: 'employee_timesheet/list?noref=true',
      data: { select: { createdAt: 1, name: 1, workDays: 1, user: { profile: { name: 1 } } } }
    };
  }
  get workCalendars() {
    return {
      uri: 'work_calendar/list',
      data: { select: { employee: { id: 1 }, user: { profile: { name: 1 } } } }
    };
  }
  get _workCalendars() {
    return {
      uri: 'work_calendar/list?noref=true',
      data: { select: { createdAt: 1, employee: 1, timesheet: 1, user: 1 } }
    };
  }
  get positions() {
    return { uri: 'employee_position/list', data: { select: { createdAt: 1, name: 1, user: { profile: { name: 1 } } } } }
  }
  get _positions() {
    return { uri: 'employee_position/list?noref=true', data: { select: { createdAt: 1, name: 1, user: { profile: { name: 1 } } } } };
  }
  get stores() {
    return { uri: 'store_manager/list', data: { limit: 100, select: { name: 1, storeId: 1, address: 1, user: { 'profile.name': 1 } } } };
  }
  get _stores() {
    return { uri: 'store_manager/list', data: { limit: 100, select: { name: 1, storeId: 1, user: { 'profile.name': 1 } } } };
  }
  get relocation() {
    return {
      uri: 'employee_relocation/list',
      data: {
        filter: {},
        select: {
          store: { name: 1, storeId: 1 },
          startDate: 1,
          endDate: 1,
          startTime: 1,
          endTime: 1,
          id: 1,
          employees: { profile: { name: 1, employeeId: 1 } }, updatedAt: 1, user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get localshiping() {
    return {
      uri: 'localshiping/list?noref=true&&selectall=true',
      data: {
        filter: {},
        select: {
          createdAt: { profile: { name: 1 } },
          creator: { profile: { name: 1 } },
          data: 1,
          from: 1,
          status: 1,
          time: 1,
          to: 1,
          driver: { profile: { name: 1 } },
          vehicle: { type: 1, plate: 1 },
          updatedAt: 1, user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get _relocation() {
    return {
      uri: 'employee_relocation/list?noref=true',
      data: {
        filter: {},
        page: 1,
        limit: 25,
        select: {
          store: { name: 1, storeId: 1 },
          startDate: 1,
          endDate: 1,
          startTime: 1,
          endTime: 1,
          id: 1,
          employees: { profile: { name: 1, employeeId: 1 } }, updatedAt: 1, user: { profile: { name: 1 } }
        }
      }
    };
  }
  get leave() {
    return {
      uri: 'employee_leave/list',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          start: 1,
          end: 1,
          type: 1,
          status: 1,
          reason: 1,
          id: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get _leave() {
    return {
      uri: 'employee_leave/list?noref=true',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          start: 1,
          end: 1,
          type: 1,
          reason: 1,
          status: 1,
          id: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get workReview() {
    return {
      uri: 'employee_work_review/list',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          date: 1,
          status: 1,
          updatedAt: 1,
          reason: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get depositInterest() {
    return {
      uri: 'employee_passbook/list',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          paymentDate: 1,
          createdAt: 1,
          status: 1,
          interestRate: 1,
          amount: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get salaryAdvance() {
    return {
      uri: 'employee_salary_advance/list',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          status: 1,
          updatedAt: 1,
          reason: 1,
          user: { profile: { name: 1 } },
          paymentDate: 1,
          requestDate: 1,
          amount: 1,
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get absence() {
    return {
      uri: 'employee_absence/list',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          start: 1,
          end: 1,
          type: 1,
          status: 1,
          reason: 1,
          id: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get _absence() {
    return {
      uri: 'employee_absence/list?noref=true',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1 } },
          start: 1,
          end: 1,
          type: 1,
          status: 1,
          id: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get overtime() {
    return {
      uri: 'employee_overtime/list',
      data: {
        filter: {},
        select: {
          employees: { profile: { name: 1, employeeId: 1 } },
          start: 1,
          end: 1,
          type: 1,
          status: 1,
          id: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get _overtime() {
    return {
      uri: 'employee_overtime/list?noref=true',
      data: {
        filter: {},
        select: {
          employees: { profile: { name: 1, employeeId: 1 } },
          start: 1,
          end: 1,
          type: 1,
          status: 1,
          id: 1,
          updatedAt: 1,
          user: { profile: { name: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get salarycomponent() {
    return {
      uri: 'salary_component/list',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1, employeeGroup: { name: 1 } } },
          amount: 1,
          reason: 1,
          type: 1,
          applyMonth: 1,
          status: 1,
          id: 1,
          title: 1,
          updatedAt: 1,
          createdAt: 1,
          user: { profile: { name: 1, employeeId: 1, employeeGroup: { name: 1 } } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get _salaryComponent() {
    return {
      uri: 'salary_component/list?noref=true&&selectall=true',
      data: {
        filter: {},
        select: {
          employee: { profile: { name: 1, employeeId: 1, employeeGroup: 1 } },
          amount: 1,
          reason: 1,
          type: { name: 1, amount: 1, type: 1 },
          applyMonth: 1,
          status: 1,
          id: 1,
          updatedAt: 1,
          createdAt: 1,
          user: { profile: { name: 1, employeeId: 1 } }
        },
        page: 1,
        limit: 25,
      }
    };
  }
  get timekeepings() {
    return {
      uri: 'formula_timekeeping/list',
      data: {
        filter: {},
        select: { type: 1, workhours: 1, standard: 1, overtimeRate: 1, employee: { id: 1, profile: { name: 1 } }, user: { id: 1, profile: { name: 1 } } },
        page: 1,
        limit: 25,
      }
    };
  }
  get _timekeepings() {
    return {
      uri: 'formula_timekeeping/list?noref=true',
      data: {
        filter: {},
        select: { type: 1, workhours: 1, standard: 1, overtimeRate: 1, employee: 1, user: 1 },
        // page: 1,
        // limit: 25,
      }
    };
  }
  get salaries() {
    return {
      uri: 'formula_salary/list',
      data: {
        filter: {},
        select: {
          salary: 1, salaryAbsence: 1, name: 1, type: 1, employee: { id: 1 }, ratio: 1, allowances: 1, kpi: 1,
          'allowances.allowance': { name: 1 },
          'kpi.kpiUnit': { name: 1, price: 1 },
        },
        // page: 1,
        // limit: 25,
      }
    };
  }
  get _salaries() {
    return {
      uri: 'formula_salary/list?noref=true',
      data: {
        filter: {},
        select: {
          salary: 1, salaryAbsence: 1, name: 1, type: 1, employee: 1, ratio: 1, allowances: 1, kpi: 1
        },
        // page: 1,
        // limit: 25,
      }
    };
  }
  get allowances() {
    return {
      uri: 'employee_allowance/list',
      data: {
        filter: {},
        select: { name: 1, type: 1, amount: 1, user: { profile: { name: 1 } } },
        // page: 1,
        // limit: 25,
      }
    };
  }
  get _allowances() {
    return {
      uri: 'employee_allowance/list?noref=true',
      data: {
        filter: {},
        select: { name: 1, type: 1, amount: 1, user: 1 },
        // page: 1,
        // limit: 25,
      }
    };
  }

  get phones() {
    return {
      uri: 'phone/list?selectall=true',
      data: {
        select: { number: 1, status: 1, holder: { profile: { name: 1 } } },
        filter: {},
        page: 1,
        limit: 25,
      }
    }
  }
  get _phones() {
    return {
      uri: 'phone/list?noref=true',
      data: {
        select: {
          number: 1, status: 1,
          holder: { profile: { name: 1, employeeId: 1, employeeGroup: 1 } },
          user: { profile: { name: 1, employeeId: 1, employeeGroup: 1 } }
        },
        filter: {},
        page: 1,
        limit: 25,
      }
    }
  }
  get phoneContacts() {
    return {
      uri: 'phone_contact/list',
      data: {
        select: { number: 1, status: 1, data: 1, user: { profile: { name: 1 } } },
        filter: {},
        page: 1,
        limit: 25,
      }
    }
  }
  get _phoneContacts() {
    return {
      uri: 'phone_contact/list?noref=true',
      data: {
        select: { number: 1, status: 1, data: 1, user: 1 }
      },
      filter: {},
      page: 1,
      limit: 25,
    }
  }

  get phoneRecords() {
    return {
      uri: 'callrecord/list?selectall=true',
      data: {
        select: { phone: { number: 1, holder: { email: 1 } }, participant: 1, contact: { data: { name: 1 }, number: 1 }, duration: 1, type: 1, createdAt: 1, callAt: 1, user: { profile: { name: 1 } } },
        filter: {},
        page: 1,
        limit: 25,
      }
    }
  }
  get _phoneRecords() {
    return {
      uri: 'callrecord/list?noref=true',
      data: {
        select: { phone: 1, contact: 1, duration: 1, type: 1, createdAt: 1, callAt: 1, user: 1 },
        filter: {},
        page: 1,
        limit: 25,
      }
    }
  }
  get reportLateEarly() {
    return {
      uri: 'employee_attendance/report_checkin_late_early',
      data: {}
    };
  }
  get reportActualLeave() {
    return {
      uri: 'employee_attendance/report_actual_leave',
      data: {}
    };
  }
  get reportPlannedLeave() {
    return {
      uri: 'employee_attendance/report_planned_leave',
      data: {}
    };
  }
  get reportAbsenceOfGroup() {
    return {
      uri: 'employee_attendance/report_absence_of_group',
      data: {}
    };
  }
  get reportOvertimeOfGroup() {
    return {
      uri: 'employee_attendance/report_overtime_of_group',
      data: {}
    };
  }
  get reportEmployeeAbsence() {
    return {
      uri: 'employee_attendance/report_employee_absence',
      data: {}
    };
  }
  get reportEmployeeLateEarly() {
    return {
      uri: 'employee_attendance/report_employee_late_early',
      data: {}
    };
  }
  get reportEmployeeOvertime() {
    return {
      uri: 'employee_attendance/report_employee_overtime',
      data: {}
    };
  }
  get reportLateEarlyOfGroup() {
    return {
      uri: 'employee_attendance/report_late_early_of_group',
      data: {}
    };
  }
  get kpiUnits() {
    return {
      uri: 'employee_kpi_unit/list?noref=true',
      data: {}
    };
  }
  get kpis() {
    return {
      uri: 'formula_salary_kpi/list',
      data: {
        limit: 25,
        filter: {},
      }
    };
  }
  get _kpis() {
    return {
      uri: 'formula_salary_kpi/list?noref=true&&selectall=true',
      data: {
        select: {
          quantity: 1, unit: { name: 1 },
          employee: { profile: { name: 1, employeeId: 1, employeeGroup: 1 } },
          user: { profile: { name: 1, employeeId: 1, employeeGroup: { name: 1 } } },
          updatedAt: 1, createdAt: 1
        },
        limit: 25,
        filter: {},
      }
    };
  }
  get _payslips() {
    return {
      uri: 'employee_payslip/list?selectall=true',
      data: {
        select: {
          employee: { profile: { name: 1, employeeId: 1, employeeGroup: 1 }, data: 1 },
          user: { profile: { name: 1, employeeId: 1, employeeGroup: { name: 1 } }, data: 1 },
          month: 1,
          data: 1,
          status: 1,
          updatedAt: 1, createdAt: 1
        },
        limit: 25,
        filter: {},
      }
    };
  }

}